import React from "react";
import { Form } from "antd";
import { inputTypeComponent } from "../helper";
import { propHasValue } from "../../../components/DynamicFormNew/helper";

export default function GroupInput({
  value = {},
  groupInputs = [],
  onChange
}) {
  const getFormItemName = (data) => {
    if (typeof data.repeatIndex === 'number' && data.repeatIndex >= 0) {
      return [data.repeatIndex, data.inputName]
    } else if (propHasValue(data.inputName)) {
      return [data.name, data.inputName]
    }
    return data.name;
  }
  return groupInputs ? groupInputs.map((i, key) =>
    <Form.Item
      key={key}
      noStyle
      style={{ width: '50%' }}
      label={null}
      name={getFormItemName(i.data)}
      fieldKey={getFormItemName(i.data)}
      initialValue={i.data.value}
      required={
        i.data.rules && i.data.rules instanceof Array &&
          i.data.rules.filter(r => r.required).length > 0 ? true : false
      }
      {...i.data.props}>
      {inputTypeComponent[i.type](i.data, i.forms)}
    </Form.Item>
  ) : null;
}
